const cookiesObject = Object.fromEntries(
  document.cookie.split(';').map((cookie) => {
    const [k, v] = cookie.trim().split('=');
    return [k, v];
  }),
);
